let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jFpYr")).then(() => parcelRequire('gzNft'));